import { computed } from 'vue'

import type { BtnCheckboxProps } from '../types/interfaces'

import { faSquare } from '@fortawesome/pro-regular-svg-icons'
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons'

interface UseBtnCheckboxOptions {
  props: BtnCheckboxProps
  onClick: () => void
}

interface UseBtnCheckboxReturn {
  refIsError: ComputedRef<boolean>
  isChecked: (selected: boolean) => typeof faSquareCheck | typeof faSquare
  handleClick: () => void
}

export const useBtnCheckbox = ({ props, onClick }: UseBtnCheckboxOptions): UseBtnCheckboxReturn => {
  const refIsError = computed<boolean>(() => props.mode === 'error')

  const isChecked = (selected: boolean) => selected ? faSquareCheck : faSquare

  const handleClick = (): void => {
    onClick()
  }

  return {
    refIsError,
    isChecked,
    handleClick,
  }
}
